import { ApiRequestFilters } from '../../../types/api-request-filters';
import { PricingItemTypeEnum } from '../../pricing-items/enums/pricing-item-type.enum';

/**
 * Vehicle category pricing item templates filters
 */
export class VehicleCategoryPricingItemTemplatesFilters extends ApiRequestFilters {
	/**
	 * Types
	 */
	types?: PricingItemTypeEnum[];
}
